import { captureError } from '@/config/sentry';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);

const getFCMToken = async (swReg: ServiceWorkerRegistration) => {
  try {
    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });
    return token || null;
  } catch (error) {
    captureError(error);
    return null;
  }
};

export const askPermissionAndGetFcmToken = async (swReg: ServiceWorkerRegistration): Promise<string | null> => {
  if (!('Notification' in globalThis)) return null;
  if (!(await isSupported())) return null;

  const permission = await Notification?.requestPermission();
  if (permission !== 'granted') return null;

  const token = await getFCMToken(swReg);
  return token;
};

/** Silent fetch if already granted (no prompt). */
export const getFcmTokenIfGranted = async (swReg: ServiceWorkerRegistration): Promise<string | null> => {
  if (!('Notification' in globalThis)) return null;
  if (!(await isSupported())) return null;

  if (Notification?.permission !== 'granted') return null;

  const token = await getFCMToken(swReg);
  return token;
};
